<template>
  <div id="kit-view">
    <div class="mobile-header" v-if="isMobile">
      <div class="header-nav">
        <div class="back-button">
          <router-link to="/">
          {{$t('menu.back')}}
          </router-link>
        </div>
        <div class="toggle-button hambuger-icon" v-on:click="openMenu" v-if="isMobile">☰</div>
      </div>
      <div class="logo-container"></div>
    </div>
    <div class="desktop-header" v-else>
      <nav-header></nav-header>
      <div class="desktop-logo-container">
        <kit-header-desktop></kit-header-desktop>
      </div>
    </div>
    <div class="topic-container" v-if="loaded">
      <topic-button v-for="(topic,i) in topics" v-bind:topic="topic" :key="i"/>
    </div>
    <div class="loader-panel" v-else>
      <loader></loader>
    </div>
    <div class="support-footer-container" v-if="isMobile">
      <support-footbar></support-footbar>
    </div>
  </div>
</template>

<script>
  import KitApi from '@/api/KitApi'
  import TopicButton from "../components/TopicButton";
  import SupportFootbar from "../components/SupportFootbar";
  import NavHeader from "../components/NavHeader";
  import KitHeaderDesktop from "../components/KitHeaderDesktop";
  import Loader from "../components/Loader";

  export default {
    name: "kit",
    components: {
      NavHeader,
      SupportFootbar,
      TopicButton,
      Loader,
      KitHeaderDesktop
    },
    created() {
      this.$i18n.locale = 'ar'
      !this.$store.state.kitLoaded && this.$getGapiClient().then(gapi => {
        this.$store.commit('getKitData', gapi)
      })
    },
    computed: {
      kit () {
        return this.$store.state.kitLoaded ? this.$store.state.kitData : []
      },
      loaded () {
        return this.$store.state.kitLoaded
      },
      topics() {
        var topics = []
        this.kit.forEach((el)=>{
          if (!topics.find((t) => t.topic_EN == el.topic_EN)){
            topics.push({
                topic_EN: el.topic_EN,
                topic_AR: el.topic_AR
              })
          }
        })
        return topics
      },
      isMobile(){
        return this.$store.state.isMobile
      }
    },
    methods: {
      contentByTopic(topic){
        return this.kit.filter((el)=>{el.topic_EN == topic})
      },
      openMenu(event){
        this.$emit('openMenu')
        event.stopPropagation();
      }
    }
  }
</script>

<style lang="stylus" scoped>

#kit-view
  min-height: 100vh;
  max-height: 100vh;

  .mobile-header
    background: #72E3C3;
    padding-bottom: 50px

  .logo-container
    margin-top: -10px;
    min-height: 100px;
    margin-bottom: 15px
    background: url('~@/../static/images/kit-logo-white.svg') no-repeat center center;

  .kit-container
    height: calc(100vh - 60px);
    overflow: auto;

  .header-nav
    width: 90%;
    margin-left: 5%;
    display: flex;
    color: #fff;
    align-items: center
    a
      text-decoration: none;
      color: #fff;
    .back-button
      background: url('~@/../static/icons/back.svg') no-repeat left center;
      padding-left: 25px;

    .toggle-button
      margin-left: auto;
      font-size: 30px;
      color: #fff;
      margin-top: 10px;

  .desktop-logo-container
    min-height 200px
    background: #72E3C3;
    padding-bottom: 80px

  .topic-container
    display: flex;
    flex-direction: row;
    max-width: 90%;
    width: 90%;
    padding: 5%;
    margin-top: -80px;
    flex-flow: row wrap;
    margin-bottom: 40px;

  .support-footer-container
    position: fixed;
    bottom: 0
    width: 100%;

.loader-panel
  position: absolute;
  top: 50%;
  transform: translateX(-50%);
  left: 50%;

@media only screen and (min-width: 768px)
  #kit-view
    .topic-container
      margin-top: -100px;
      width: 80%;
      padding: 0 10%;
</style>



// WEBPACK FOOTER //
// src/views/Kit.vue